import { render, staticRenderFns } from "./chooseRoleDialog.vue?vue&type=template&id=2662f6fc&scoped=true&"
import script from "./chooseRoleDialog.vue?vue&type=script&lang=js&"
export * from "./chooseRoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./chooseRoleDialog.vue?vue&type=style&index=0&id=2662f6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2662f6fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2662f6fc')) {
      api.createRecord('2662f6fc', component.options)
    } else {
      api.reload('2662f6fc', component.options)
    }
    module.hot.accept("./chooseRoleDialog.vue?vue&type=template&id=2662f6fc&scoped=true&", function () {
      api.rerender('2662f6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseRoleDialog.vue"
export default component.exports